<template>
<div class="hy-slinfo baoming" >
    <div class="info-bannerbox">
      <van-swipe class="my-swipe" :autoplay="5000">
        <van-swipe-item v-for="(item, index) in postsData.banner" :key="index">
          <img v-lazy="item.pic_url" width="100%" @click="goPath(item.app_url.rule)" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="info-cont" v-if="postsData.conference != ''">
      <div class="info-topTitle" v-if="postsData.conference">
        <div class="title">
          <h5>{{postsData.conference.name}}</h5>
          <span class="info_icon" v-if="postsData.conference.type == 1">会议</span>
          <span class="info_icon" v-else-if="postsData.conference.type == 2">沙龙</span>
          <span class="info_icon" v-else="postsData.conference.type == 3">活动</span>
        </div>
        <div class="info_pricebox">
          <div class="l"  v-if="postsData.is_free"><span class="iconfont">&#xe63a;</span><span class="nums">¥{{postsData.ticket.min_price}}</span>起</div>
          <div class="l"  v-else><span class="iconfont">&#xe63a;</span><span class="nums">免费</span></div>
          <span class="r">{{postsData.like_count}}感兴趣</span>
        </div>
        <div class="infotimes">
          <span class="iconfont">&#xe67f;</span>时间：{{postsData.conference.start_time,'Y-M-D h:m'|formatDates}}至{{postsData.conference.end_time,'Y-M-D h:m'|formatDates}}
        </div>
        <div class="infotimes"  @click="getClickInfo">
          <span class="iconfont">&#xe64d;</span>地点：{{postsData.conference.region}}{{postsData.conference.specific_address}}
        </div>
        <div class="infotimes" v-if="postsData.conference.organizers != ''">
          <span class="iconfont">&#xe671;</span>主办单位：<span class="blue">{{postsData.conference.organizers}}</span>
        </div>
        <div class="infotimes" v-if="postsData.conference.organizers != ''">
          <span class="iconfont">&#xe6bb;</span>信息提供者：<span>{{postsData.conference.informant}}</span>
        </div>
      </div>
      <div class="info-listbox">
        <van-tabs v-model="active" scrollspy sticky>
          <van-tab v-for="(item, index) in postsData.column" :title="item.title">
            <!--单页-->
            <div class="info_item info_textinfobox" v-if="item.type == 1">
              <h5><img :src="item.column_icon_url" alt="">{{item.title}}</h5>
              <div class="info_item_text" v-html="item.content">
              </div>
            </div>
            <!--资料-->
            <div class="info_item info_downlist" v-else-if="item.type == 10">
              <h5><img :src="item.column_icon_url" alt="">{{item.title}}</h5>
              <div class="info_item_list">
                <ul>
                  <li v-for="(items,index2) in item.list_info" :key="index2">
                    <div class="imgbox">
                      <img src="../../assets/images/index/hy_word.png" alt v-if="items.type == 'word'" />
                      <img src="../../assets/images/index/hy_pdf.png" alt v-else-if="items.type == 'pdf'" />
                      <img src="../../assets/images/index/hy_ppt.png" alt v-else-if="items.type == 'ppt'" />
                      <img src="../../assets/images/index/hy_zip.png" alt v-else />
                    </div>
                    <div class="textbox">
                      <h5>{{items.title}}</h5>
                      <p>{{(items.size/1024).toFixed(2)}}MB</p>
                    </div>
                    <div class="hy_zlbtn" v-if="items.is_buy">
                      <a href="javascript:;" @click="downfile(items.id)">
                        <span class="iconfont">&#xe703;</span> 下载
                      </a>
                    </div>
                  </li>
                </ul>
                <!--  <a href="javascript:;" class="getMore" v-if="filebox.getFilebtn" @click="getMoreDown(index)">
加载更多
<span class="iconfont get_more_icon_all">&#xe699;</span>
  </a>
<a href="javascript:;" class="getMore" v-else>
没有了
  </a>-->
              </div>
            </div>
            <!--视频-->
            <div class="info_item info_video" v-else-if="item.type == 11">
              <h5><img src="../../assets/images/icon/icon_sl2.png" alt="">{{item.title}}</h5>
              <div class="info_item_list">
                <ul>
                  <li v-for="(items, index) in item.list_info" :key="index" @click="videoPlay(items.id)">
                    <div class="imgbox">
                      <img :src="item.video_cover_url" alt />
                      <span class="iconfont icon">&#xe696;</span>
                    </div>
                    <div class="textbox" v-if="items.info">
                      <h5>
                        <a href="/">{{items.title}}</a>
                      </h5>
                      <p class="time">{{items.create_time,'Y-M-D h:m'|formatDates}} 时长：{{items.duration}}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <!--资讯-->
            <div class="info_item info_list" v-else-if="item.type == 9">
              <h5><img src="../../assets/images/icon/icon_sl3.png" alt="">{{item.title}}</h5>
              <div class="info_item_list">
                <ul>
                  <li v-for="(items,index3) in item.list_info" :key="index3">
                    <div class="imgbox">
                      <img :src="items.uploadImgId_url" alt @click="goHref(index,index3)" />
                    </div>
                    <div class="textbox">
                      <h5 @click="goHref(index,index3)">
                        {{items.name}}
                      </h5>
                      <p class="time">{{items.author}} {{items.release_time,'Y-M-D h:m'|formatDates}}</p>
                      <div class="hy_bottom">
                        <p class="num">{{items.click_volume}}人已看</p>
                        <a href="javascript:;" class="hy_zanBtn active iconfont" @click="newsDigg(items.id,index,index3)">
                          &#xe607;
                          <span>{{items.count}}</span>
                        </a>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <!--嘉宾-->
            <div class="info_item info_jiabin" v-else-if="item.type == 5">
              <h5> <img :src="item.column_icon_url" alt="">{{item.title}}
                <router-link class="link" :to="{ name: 'peopleList', params: { id: id }}">查看更多 ></router-link>
              </h5>
              <div class="info_item_list">
                <ul>
                  <li v-for="(items,index3) in item.list_info" :key="index3" @click="goPeopleInfo(index,index3)">
                    <template v-if="index3 < 6">
                      <router-link class="links" :to="{ name: 'peopleInfo', params: { id: items.id }}">
                        <div class="imgbox">
                          <img :src="items.head_img" alt />
                        </div>
                        <h5 class="hy_name">{{items.name}}</h5>
                        <p class="hy_type">{{items.domain}}</p>
                        <p class="hy_jigou">{{items.company}}</p>
                      </router-link>
                    </template>
                  </li>
                </ul>
              </div>
            </div>
          </van-tab>
        </van-tabs>

        <!--<div class="info_item info_lianxi" v-if="postsData.conference">
  <h5>联系我们</h5>
  <div class="lianxi_text">
    <p>联系人：{{postsData.conference.contact_name}}</p>
    <p>电话：{{postsData.conference.tel}}</p>
    <p>地址：{{postsData.conference.contact_address}}</p>
  </div>
</div>-->
      </div>
    </div>
    <div class="info_fixedbottom">
      <!--content   感兴趣的居中  active 状态-->
      <div class="info_xingqu" :class="[postsData.is_free  == true ? '':'content',postsData.is_like ? 'active':'']">
        <a class="link" :class="postsData.is_like ? 'no_hui':''" @click="ganxingqu()"><span class="iconfont">&#xe60b;</span>{{postsData.is_like ? '感兴趣':'感兴趣'}}</a>
      </div>
      <template v-if="postsData.is_free == true">
          <div class="info_baomingBtn" v-if="(postsData.conference.parallel == 0 ) || (postsData.conference.parallel == 1 &&  postsData.conference.independent == 1)">
            <a class="link" @click="goBaoming()">我要报名</a>
         </div>
      </template>
    </div>

    <!--视频播放-->
    <div class="info_videobox" v-if="videoSet.open">
      <div class="info_play">
        <video id="video1" style="object-fit:cover; object-position: center center;" x-webkit-airplay="" playsinline="" webkit-playsinline="" x5-video-player-type="h5-page" x5-video-player-fullscreen="false" :src="videoSet.video_url" class="v1" muted controls></video>
        <span class="iconfont closeVideobox" @click="closeVideobox()">&#xe629;</span>
      </div>
    </div>
    <!--底部按钮-->
    <div class="hy-fixed-userBtn">
      <span class="iconfont fixed-link" @click="openFooterNav()">&#xe60c;</span>
      <div class="hy_footer_nav" :class="footerNav? 'active':''">
        <a class="nav-link iconfont" :href="'/index/conference/template?id='+id">&#xe66a; <span class="text">当前会议首页</span></a>
        <router-link class="nav-link iconfont" to="/">
          &#xe60e;
          <span class="text">会议平台首页</span>
        </router-link>
        <router-link class="nav-link iconfont" to="/myEnroll">
          &#xe609;
          <span class="text">我的会议信息</span>
        </router-link>
      </div>
    </div>
  <template v-if="postsData.conference != ''">
    <footerFixed :id="conference.conference.id" :jump-page="postsData.conference.jump_page"/>
  </template>


  </div>
</template>
<script>
  import {
    formatDates
  } from '@/assets/js/date.js';
  import {
    getCookie,
    delCookie,
    setCookie
  } from '../../http/util'; // cookie操作
  //百度地图
  import {
    BaiduMap,
    BmControl,
    BmView,
    BmAutoComplete,
    BmLocalSearch,
    BmMarker,
    BmInfoWindow
  } from 'vue-baidu-map'
  import footerFixed from  '@/components/common/fixed_setting'
  export default {
    components: {
      BaiduMap,
      BmControl,
      BmView,
      BmAutoComplete,
      BmLocalSearch,
      BmMarker,
      BmInfoWindow,
      footerFixed
    },
    data() {
      return {
        id: "",
        active: 0,
        footerNav: false,
        postsData: {
          banner: [],
          conference: '',
          column: [],
          guest: {
            guest_infos: []
          },
          is_free: true,
          video: [],
          news: [],
          file: [],
          ticket: {
            data: [],
            min_price:0,
          },
          is_like: false,
          like_count:0
        },
        thisStatus: 0,
        filebox: {
          getFilebtn: true,
          page: 2,
          pagesize: 3
        },
        videoSet: {
          open: false,
          video_url: ''
        },
        center: {
          lng: 116.440424,
          lat: 39.920019
        },
        zoom: 20,
        mapStyle: {
          width: '100%',
          height: '250px',
          margin: '10px 0px 20px'
        },
      };
    },
    created() {
      this.id = this.$route.params.id;
      this.list();
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        overlay: true,
        duration: 0
      });
    },
    /* 时间过滤 */
    filters: {
      formatDates
    },
    methods: {
      //锚点跳转
      goAnchor(selector) {
        var anchor = this.$el.querySelector(selector)
        document.documentElement.scrollTop = anchor.offsetTop
      },
      //储存本地作者信息
      goPeopleInfo(i, n) {
        var _this = this;
        localStorage.setItem('guest', JSON.stringify(_this.postsData.column[i].list_info[n]));
      },
      //视频播放
      videoPlay(id) {
        var _this = this;
        let url = "/ac1/conference/resource/videoUrl";
        let params = {
          id: id,
          conference_id: _this.id
        };
        _this.$get(url, params).then(res => {
          console.log(res);
          if (res.posts.is_buy) {
            _this.videoSet.video_url = res.posts.url;
            _this.videoSet.open = true;
            setTimeout(function() {
              var video = document.getElementById("video1");
              video.play();
            }, 2000)
          } else {
            _this.$toast('购买门票后可观看该视频资料');
          }
        });

      },
      /*关闭视频弹出*/
      closeVideobox() {
        var _this = this;
        _this.videoSet.open = false;
        setTimeout(function() {
          var video = document.getElementById("video1");
          video.pause(); //暂停控制
        }, 1000)
      },
      //资讯点赞
      newsDigg(id, i, n) {
        var _this = this;
        let url = "/resource/diggrs";
        let params = {
          'resource_id': id,
          resource_type: 3
        };
        _this.$post(url, params).then(res => {
          //  console.log(res);
          var datas = res.posts;
          if (datas == 1) {
            _this.postsData.column[i].list_info[n].count += 1;
          } else if (datas == '0') {
            _this.postsData.column[i].list_info[n].count -= 1;
          }
        });
      },
      //咨询跳转
      goHref(i, n) {
        var _this = this;
        var box = _this.postsData.column[i].list_info[n]
        if (box.jump_status == 1) {
          window.location.href = box.jump_link;
        } else {
          _this.$router.push({
            name: 'newinfoPage',
            params: {
              id: box.id
            }
          });
        }
      },
      //下载方法
      downfile(id) {
        var _this = this;
        let url = "/ac1/conference/fileDownload?id=" + id;
        window.location.href = url;
      },
      //会议资料分页
      getMoreDown(i) {
        var _this = this;
        let url = "/ac1/conference/filePaging";
        let params = {
          id: _this.id,
          page: _this.filebox.page,
          pagesize: _this.filebox.pagesize,
          c_id: _this.postsData.column[i].id
        };
        _this.$get(url, params).then(res => {
          console.log(res);
          _this.filebox.page = parseInt(_this.filebox.page) + 1;
          var datas = res.posts;
          var filellist = JSON.parse(JSON.stringify(_this.postsData.column[i].list_info));
          if (datas.length == _this.filebox.pagesize) {
            _this.postsData.column[i].list_info = filellist.concat(datas);
          } else {
            _this.postsData.column[i].list_info = filellist.concat(datas);
            _this.filebox.getFilebtn = false;
          }
        });
      },
      //banner跳转方法
      goPath(path) {
        if (path == "") {
          return false;
        }
        // this.$router.push(path);
        window.location.href = path;
      },
      //打开底部链接
      openFooterNav(val) {
        //   this.$toast(val);
        if (this.footerNav) {
          this.footerNav = false;
        } else {
          this.footerNav = true;
        }
      },
      list() {
        var _this = this;
        let url = "/ac1/conference/confDetail";
        let params = {
          id: _this.id
        };
        _this.$get(url, params).then(res => {
          console.log(res);
          if (res.code == 2026) {
            this.$router.push('/power');
          }
          var boxdata = res.posts.data;
          _this.center.lng = boxdata.conference.longitude;
          _this.center.lat = boxdata.conference.latitude;
          _this.postsData.banner.push({
            pic_url: boxdata.conference.cover_url,
            url: ""
          });
          _this.postsData.conference = boxdata.conference;
          _this.postsData.column = boxdata.column;
          _this.postsData.guest = boxdata.guest;
          _this.postsData.is_free = boxdata.is_free;
          _this.postsData.news = boxdata.news;
          _this.postsData.file = boxdata.file;
          _this.postsData.video = boxdata.video;
          _this.postsData.ticket = boxdata.ticket;
          _this.postsData.is_like = boxdata.is_like;
          _this.postsData.like_count = boxdata.like_count;
          if (boxdata.conference.status_str == '报名中') {
            _this.thisStatus = 0;
          } else {
            _this.thisStatus = 1;
          }
          var share_box = res.posts.share_info;
          var wxShareInfo = {
            title: share_box.title,
            info: share_box.desc,
            shareurl: share_box.link,
            img: share_box.img
          };
          var shareData = {
            data: wxShareInfo, //分享配置信息
            ifshare: true,
            that: _this
          };
          sessionStorage.setItem('hy_shareData' + _this.id, JSON.stringify(wxShareInfo));
          _this.$WXConfig.wxShowMenu(shareData);
          this.$toast.clear();
        });
      },
      isMobile() {
        var _this = this;
        var flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        );
        if(flag === null) {
          console.log("pc端");
          _this.$dialog.confirm({
            titl: '跳转提示',
            message: '报名会议需要先登录账号 (如果您还不是帐号请先注册)',
            confirmButtonText:'登录',
          })
            .then(() => {
            // on confirm
            window.location.href = "/login/login.html?request_url=" + encodeURIComponent(window.location.href)+'&nologo=1';
          })
            .catch(() => {
            // on cancel
          });
        }else {
          console.log("移动端");
          window.location.href = "/login/login.html?request_url=" + encodeURIComponent(window.location.href)+'&nologo=1';
        }
      },
      goBaoming() {
        var _this = this;
        var tokens = getCookie('member_token');
        if (tokens === null) {
          _this.isMobile();
        } else {
          let url = '/member/reauth';//刷新token授权
          let params = {};
          _this.$get(url, params).then(res => {
            if(res.code == 1){
              setCookie("member_token",res.posts.token);
              this.$router.push('/enroll01/' + _this.id);
            }else{
              _this.isMobile();
            }
          },function(res){
            _this.$toast(res.msg);
          });
        }
      },
      getClickInfo(e) {
        var _this = this;
        _this.$dialog.confirm({
            titl: '跳转提示',
            message: '即将跳转到第三方地图，点击确认跳转',
          })
          .then(() => {
            // on confirm
            const a = document.createElement('a') // 创建a标签
            a.setAttribute('href', '') // href链接
            a.setAttribute('target', '') // target属性  打开一个新窗口   好像只有在电脑端调试时有用，手机上无效
            //百度地图
            a.href = "http://api.map.baidu.com/geocoder?location=" + e.point.lat + "," + e.point.lng + "&coord_type=bd09ll&output=html&src=webapp.baidu.openAPIdemo";
            a.click() // 自执行点击事件
          })
          .catch(() => {
            // on cancel
          });
      },
      syncCenterAndZoom(e) {
        // debugger
        /*const {lng, lat} = e.target.getCenter()//地图当前的经纬度
        this.center.lng = lng
        this.center.lat = lat
        this.zoom = e.target.getZoom()//地图当前的缩放比例*/
      },
      ganxingqu() {
        var _this = this;
        let url = "/ac1/conference/MemberLike";
        let params = {
          id: _this.id,
        };
        if (_this.postsData.is_like == true) {
          _this.$dialog.confirm({
              title: '提示',
              message: '是否确认取消报名?',
            })
            .then(() => {
              // on confirm
              _this.$post(url, params).then(res => {
                if (res.code == 1) {
                  if (res.posts == 1) {
                    _this.postsData.is_like = true;
                    _this.$toast('报名成功！');
                  } else if (res.posts == 2) {
                    _this.postsData.is_like = false;
                    _this.$toast('取消成功！');
                  }
                } else {
                  _this.$toast(res.msg);
                }
              }).catch(err => {
                _this.loading = false;
                _this.$toast('网络错误，请稍后再试');
              });
            })
            .catch(() => {
              // on cancel
              return false;
            });
        } else {
          _this.$post(url, params).then(res => {
            if (res.code == 1) {
              if (res.posts == 1) {
                _this.postsData.is_like = true;
                _this.$toast('报名成功！');
              } else if (res.posts == 2) {
                _this.postsData.is_like = false;
                _this.$toast('取消成功！');
              }
            } else {
              _this.$toast(res.msg);
            }
          }).catch(err => {
            _this.loading = false;
            _this.$toast('网络错误，请稍后再试');
          });
        }
      }
    }
  };
</script>
<style lang="less">
  .info-listbox {
    width: 100%;

    .van-tabs {
      >div {
        .van-sticky {
          margin-bottom: 20px;
        }
      }

      .van-tabs__line {
        background-color: #2b68da;
      }
    }
  }
</style>
<style scoped>
  @import '../../assets/css/layui.css';

  /*.info_textinfobox .info_item_text>>>p {
    font-size: 28px;
    color: #333;
    line-height: 40px;
    text-align: left;
  }*/

  .info_textinfobox .info_item_text>>>img {
    max-width: 100%;
    display: block;
    margin: 10px auto;
    height: auto!important;
  }
</style>
<style lang="less" scoped>

</style>
